module.exports = __webpack_public_path__ + "static/media/stille_klokka.5963176c.m4a";